module.exports = __webpack_public_path__ + "img/gentlemen-club-story-4.7b480c78.png";